import React from "react";
import AddUsers from "./users/AddUsers";
import FetchUsers from "./users/FetchUsers";

const ManageUsers = () => {
  return (
    <>
      <AddUsers />
      <FetchUsers />
    </>
  );
};

export default ManageUsers;
